<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs();

// Símbolo colorido da marca (balão com o A) — funciona nos temas claro e escuro
const logo = '/brand-assets/icon.svg?v=atende2';
</script>

<template>
  <img v-bind="attrs" :src="logo" />
</template>
